import { BBadge } from './badge';
import { pluginFactory } from '../../utils/plugins';
var BadgePlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BBadge: BBadge
  }
});
export { BadgePlugin, BBadge };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/badge/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/badge/index.js
// module chunks = 1